import React, { Fragment, useEffect } from 'react';
import * as PropTypes from 'prop-types';

import {
  redirectToPharmacy,
  redirectToVisitDetails,
  redirectToAppointmentOverview,
  redirectToProviders,
  redirectToRescheduleProviderDetails,
} from '../../../utils/appointments/redirect-utils';
import Loader from '../../common/Loader';
import AppointmentHeader from '../Components/AppointmentHeader';
import { enhance } from './enhance';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import useNavigateToPreviousPage from '../hooks/useNavigateToPreviousPage';

function AppointmentConsentForm({
  loading,
  fetchConsent,
  userId,
  consentsData,
  visitType,
  service,
  locationId,
  consentsLoading,
  openModalConsents,
  organizationName,
  isUrgentVisitFlow,
  isRescheduleFlow,
  providerId,
}) {
  usePageView('Get Care | Sign Consent Form');

  const { navigateToPrevPage } = useNavigateToPreviousPage();

  useEffect(() => {
    fetchConsent({
      locationId,
      serviceId: service.id,
      visitTypeCode: visitType.code,
      userId,
    });
  }, []);

  const handleBack = () => {
    if (isRescheduleFlow) {
      return redirectToRescheduleProviderDetails({
        providerId,
        locationId,
      });
    }

    return navigateToPrevPage();
  };

  useEffect(() => {
    if (consentsData && !consentsData.allSigned) {
      const { consents } = consentsData;
      const allConsents = consents.filter(({ accepted }) => !accepted);

      openModalConsents({
        consent: allConsents[0],
        organizationName,
        allConsents,
        patientUserInfoId: userId,
        urgentVisitFlow: isUrgentVisitFlow,
        selfSchedulingFlow: !isUrgentVisitFlow,
        rescheduleFlow: {
          providerId,
          isRescheduleFlow,
          locationId,
        },
      });
    }

    if (!consentsLoading && consentsData && consentsData.allSigned) {
      isUrgentVisitFlow
        ? redirectToPharmacy()
        : redirectToAppointmentOverview();
    }
  }, [consentsData, consentsLoading, isUrgentVisitFlow]);

  return (
    <Fragment>
      <MetaHelmet title="pages.title.getCare.consent" />
      <AppointmentHeader
        title="appointments.form.consentForm"
        handleBack={handleBack}
      />
      <div>{loading && <Loader />}</div>
    </Fragment>
  );
}

AppointmentConsentForm.propTypes = {
  fetchConsent: PropTypes.func,
  loading: PropTypes.bool,
  userId: PropTypes.number,
  consentsData: PropTypes.object,
  visitType: PropTypes.object,
  service: PropTypes.object,
  consentsLoading: PropTypes.bool,
  openModalConsents: PropTypes.func,
  organizationName: PropTypes.string,
  isUrgentVisitFlow: PropTypes.bool,
  isRescheduleFlow: PropTypes.bool,
  providerId: PropTypes.number,
  locationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default enhance(AppointmentConsentForm);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentConsentForm/index.jsx